<template>
    <div class="custom-control custom-checkbox">
        <input
            class="custom-control-input"
            :class="{'is-invalid': valid === false}"
            type="checkbox"
            :id="identifier"
            :checked="fieldValue"
            @change="updateValue($event.target.checked)"
            v-bind="$attrs"
            :aria-invalid="!valid"
            :aria-describedby="identifierError"
        >
        <label class="custom-control-label" :for="identifier" v-if="label" v-html="htmlLabel"></label>
        <label class="custom-control-label" :for="identifier" v-else-if="$slots.default"><slot />{{ requiredAsterisk }}</label>
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />
    </div>
</template>
<script>
import FormField from "@/mixins/FormField";

export default {
    name: 'CheckboxInput',
    mixins: [FormField],
    inheritAttrs: false,
}
</script>
